
import { Vue, Component } from 'vue-property-decorator';
import ProgressBarDetail from './progressbar/ProgressBarDetail.vue';
import ProgressBarBrief from './progressbar/ProgressBarBrief.vue';

@Component({
  components: {
    ProgressBarDetail,
    ProgressBarBrief,
  },
})
export default class ProgressBar extends Vue {}
